<template>
    <!-- <div> --> 
        <p v-if="type === 100" class="toast">{{ props.msg }}</p>
        <p v-if="type === 200" class="toast">{{ props.msg }}</p>
        <p v-if="type === 300" class="tool-tip">{{ props.msg }}</p>
        <p v-if="type === 400" class="tool-tip">{{ props.msg }}</p>
        
    <!-- </div> -->
</template>

<script setup>
import { onMounted, ref, watch, computed, defineEmits } from 'vue';

const props = defineProps({
    type: {
        default: 100,
        required: true,
    },
    msg: {
        default: 'msg_msg_msg_msg_msg_msg_msg_msg_msg_msg_',
        required: true,
    },
});
const emit = defineEmits(['onReturn']);

const type = computed(() => {
    return props?.type;
});

// const btnType = computed(() => {
//     return props?.type;
// });

const onClick = () => {
    // console.log('--onClick  --', props.label);
    emit('onReturn');
};
// onMounted(() => {});
</script>

<style scoped lang="scss"></style>
